import { Injectable, Injector } from "@angular/core";
import { ModuleService } from "./ModuleService";
import { IOModuleService } from "./IOModule.service";
import { PulseLoaderService } from "../../common/pulse-loader/pulse-loader.service";
import { TraceService } from "../trace.service";

@Injectable({
  providedIn: 'root'
})

export class BarcodeScannerModuleService extends ModuleService {

  private retryTimeout: any;
  private tmpPayload = '';
  private onQRScanned !: (event: { Payload: string }) => void;
  private onScanError !: (event: { Payload: string }) => void;

  constructor(public injector: Injector, public io_module: IOModuleService, public pulseLoader: PulseLoaderService, public traceService: TraceService) {
    super("Barcode_Scanner", injector)
    this.logger.log('BarcodeScannerModule constructor')
    this.on('OnBarcodeScannerConnected_Event', () => {
      this.logger.log('hey')
    })
  }

  public clearTimeout() {
    clearTimeout(this.retryTimeout)
    return this;
  }

  public scanQR() {
    return this.callMethod('barcodeScanner_SetBarcodeTypes', {
      "QRCODE": true
    }).then(() => {
      // return this.callMethod('barcodeScanner_EnableAllBarcodeTypes').then(() => {
      //   this.logger.log('enabled all types')
      this.logger.log('enabled qr scanning')
      return this.callMethod('barcodeScanner_ApplyManualMode').then(() => {
        this.logger.log('enabled manual mode')
        return this.triggerQR()
      })
    })
  }

  private triggerQR() {
    return this.callMethod('barcodeScanner_TriggerScanner').then(() => {
      this.logger.log('triggered scanner')
      this.retryTimeout = setTimeout(() => {
        return this.callMethod('BarcodeScanner_IsConnected').then((connected: boolean) => {
          if (connected) {
            this.triggerQR()
          }
        })
      }, 30 * 1000)
    })
  }


  cleanUp() {
    this.clearTimeout()
    this.off('onBarcodeScanned_Event', this.onQRScanned.bind(this))
    this.off('onBarcodeScannerError_Event', this.onScanError.bind(this))
    document.removeEventListener('keypress', this.handleTyping.bind(this))
    this.io_module.turnOutputDevice(false, 2)
  }

  handleTyping(e: any) {
    if (e.which == 13) {
      this.onQRScanned({ Payload: this.tmpPayload })
      this.tmpPayload = "";
    }
    else if (e.which > 31 && e.which < 127) {
      this.tmpPayload += String.fromCharCode(e.which);
    }
    // this.tmpPayload += e.key;
    // if (this.payload) {
    //   clearTimeout(this.payload)
    // }
    // this.payload = setTimeout(() => {
    //   this.onQRScanned({ Payload: this.tmpPayload })
    // }, 250);
  }

  enableQRScanning(successCallback: (event: { Payload: string }) => void, errorCallback: (event: { Payload: string }) => void) {
    this.onQRScanned = ((event) => {
      successCallback(event)
      this.cleanUp()
    })
    this.onScanError = ((event) => {
      errorCallback(event)
      this.cleanUp()
    })
    document.addEventListener('keypress', this.handleTyping.bind(this))
    this.once('onBarcodeScanned_Event', this.onQRScanned.bind(this))
    this.once('onBarcodeScannerError_Event', this.onScanError.bind(this))
    this.scanQR()
  }
}
